/* Transform-based parallax - replaces the React <Parallax> (and dated
 * background-attachment: fixed). Each [data-parallax] wraps a
 * [data-parallax-inner] that drifts at a fraction of scroll speed.
 * Set speed via [data-parallax-speed="0.2"]. Disabled for reduced motion. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var wraps = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  if (!wraps.length) return;

  var items = wraps.map(function (wrap) {
    return {
      wrap: wrap,
      inner: wrap.querySelector('[data-parallax-inner]'),
      speed: parseFloat(wrap.getAttribute('data-parallax-speed')) || 0.18
    };
  }).filter(function (i) { return i.inner; });

  var raf = 0;
  function update() {
    raf = 0;
    var vh = window.innerHeight;
    items.forEach(function (i) {
      var rect = i.wrap.getBoundingClientRect();
      var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
      i.inner.style.transform = 'translate3d(0,' + (-progress * i.speed * 100).toFixed(2) + 'px,0)';
    });
  }
  function onScroll() { if (!raf) raf = requestAnimationFrame(update); }

  update();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
})();
